export function Reconnecting() {
  // At the moment this is a placeholder in case we want to show something while we are
  // refreshing the access token to reconnect
  return <></>;
}
